// this was introduced to force preformance on a portfolio. Since the app constantly goes for the holdings,

import moment from 'moment';
import { maxBy } from 'lodash';
import ComparisonItem from '@/types/comparison-item';

// we added this holdings override so the forced data is always used
export const getComparisonItemHoldings = (item: ComparisonItem, useOverride: boolean = false) =>
  useOverride && item.overrideHoldings != null ? item.overrideHoldings : item.holdings;

/**
 * Get the earliest common inception date for comparison items.
 * This function finds the latest inception date among all items to ensure
 * all items have data for the returned date range.
 * @param items Array of comparison items
 * @param useMonthly Whether to use monthly or weekly data for rolling performance
 * @returns The earliest common inception date or null if no valid date found
 */
export const getEarliestCommonInceptionDate = (items: ComparisonItem[], useMonthly: boolean): Date | null => {
  if (!items || items.length === 0) return null;

  const inceptionDates = items
    .map(item => {
      if (item?.dates?.inception) {
        return moment(item.dates.inception);
      }

      const rolling = item?.performance?.rolling;
      if (!rolling) return null;

      const rollingArr = useMonthly ? rolling.monthly : rolling.weekly;
      const [timestamp] = rollingArr?.[0] ?? [];
      return timestamp ? moment(timestamp) : null;
    })
    .filter(Boolean);

  if (inceptionDates.length === 0) return null;

  const latestCommonInceptionDate = maxBy(inceptionDates, date => date!.valueOf());
  return latestCommonInceptionDate ? latestCommonInceptionDate.toDate() : null;
};
